angular.module('natura').controller(
  'PggEloirasModalController',
  ['$scope', '$sce', '$uibModalInstance', 'pggEloirasProvider', 'options', 'kezelesiEgyseg', 'eloiras',
    'userCanEdit',
    function ($scope, $sce, $uibModalInstance, pggEloirasProvider, options, kezelesiEgyseg, eloiras, userCanEdit) {
      $scope.options = options;
      $scope.userCanEdit = userCanEdit;
      $scope.currentPage = 1;
      $scope.selectedEloiras = eloiras;
      $scope.itemsPerPage = 1;
      $scope.kezelesiEgyseg = kezelesiEgyseg;

      $scope.totalItems = $scope.kezelesiEgyseg.children.length;

      for (var i = 0; i < $scope.kezelesiEgyseg.children.length; i++) {
        var child = $scope.kezelesiEgyseg.children[i];
        // ha már van eleve kiválasztott értéke, akkor vegye fel azt
        // induláskor
        if (child.hasOwnProperty("selected")) {
          child.selectedEloirasId = child.selected.id;
        }
        // ha van megadott előírás, akkor ne az elejéről induljon, hanem az
        // adott elemtől
        if (eloiras && child == eloiras) {
          $scope.currentPage = i + 1;
          $scope.selectedEloiras = eloiras;
        }
      }

      var _rgbaToHexAndOpacity = function (rgbaString) {
        var rgb = rgbaString.match(/^rgba?[\s+]?\([\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?/i);
        var hex = (rgb && rgb.length === 4) ? "#" + ("0" + parseInt(rgb[1], 10).toString(16)).slice(-2) +
          ("0" + parseInt(rgb[2], 10).toString(16)).slice(-2) +
          ("0" + parseInt(rgb[3], 10).toString(16)).slice(-2) : '';
        var opacity = rgbaString.split(",")[3].split(")")[0].trim();
        return {
          color: hex,
          opacity: opacity
        };
      };

      $scope.styleFunction = function (option, selectedId) {
        var RGB = _rgbaToHexAndOpacity(option.key).color;
        var A = 0.01;
        var RGBA = '(' + parseInt(RGB.substring(1, 3), 16) + ',' + parseInt(RGB.substring(3, 5), 16) + ',' + parseInt(RGB.substring(5, 7), 16) + ',' + A + ')';
        var style = {
          "background-color": option.key,
          "border": (option.id == selectedId) ? "2px solid rgba(63, 81, 181, 0.87)" : "2px solid rgba" + RGBA
        };
        return style;
      };

      $scope.ok = function () {
        var modified = [];
        angular.forEach($scope.kezelesiEgyseg.children, function (child) {
          if (child.hasOwnProperty("selectedEloirasId") && child.selectedEloirasId != child.selected.id) {
            modified.push(child);
          }
        });
        $uibModalInstance.close(modified);
      };
      $scope.cancel = function () {
        $uibModalInstance.dismiss('cancel');
      };
    }]);

angular.module('natura').controller('PggBaseInfoModalController',
  ['$scope', '$sce', '$uibModalInstance', function ($scope, $sce, $uibModalInstance) {
    $scope.ok = function () {
      $uibModalInstance.close($scope.name);
    };
    $scope.cancel = function () {
      $uibModalInstance.dismiss();
    };
  }]);

angular.module('natura').controller(
  'PggCancelModificationsModalController',
  ['$scope', '$sce', '$uibModalInstance', 'pggJstsProvider', 'feature', 'userCanEdit',
    function ($scope, $sce, $uibModalInstance, pggJstsProvider, feature, userCanEdit) {
      $scope.feature = feature;
      $scope.userCanEdit = userCanEdit;
      $scope.isValid = pggJstsProvider.isValidGeom(feature);
      $scope.ok = function () {
        $uibModalInstance.close();
      };
      $scope.cancel = function () {
        $uibModalInstance.dismiss('cancel');
      };
    }]);

angular.module('natura').controller('PggDeleteGeometryModalController',
  ['$scope', '$sce', '$uibModalInstance', function ($scope, $sce, $uibModalInstance) {
    $scope.ok = function () {
      $uibModalInstance.close();
    };
    $scope.cancel = function () {
      $uibModalInstance.dismiss('cancel');
    };
  }]);

angular.module('natura').controller('PggDeleteDatasheetModalController',
  ['$scope', '$sce', '$uibModalInstance', function ($scope, $sce, $uibModalInstance) {
    $scope.ok = function () {
      $uibModalInstance.close();
    };
    $scope.cancel = function () {
      $uibModalInstance.dismiss('cancel');
    };
  }]);

angular.module('natura').controller(
  'PggModalInstanceCtrl',
  [
    '$scope',
    '$sce',
    '$uibModalInstance',
    'pggInteractionsProvider',
    'pggScaleProvider',
    'pggAdatlapProvider',
    'pggJstsProvider',
    'feature',
    'datasheet',
    'userCanEdit',
    function ($scope, $sce, $uibModalInstance, pggInteractionsProvider, pggScaleProvider, pggAdatlapProvider,
      pggJstsProvider, feature, datasheet, userCanEdit) {

      $scope.feature = feature;
      $scope.datasheet = datasheet;
      $scope.userCanEdit = userCanEdit;

      $scope.fields = {
        // featureId : "Gazdálkodásba vont tábla azonosítója",
        name: "Gazdálkodói terület neve",
        agronomist_area_name: "Adatlap neve",
        handled_year: "Gazdálkodási év",
        cultivation: "Művelési ág",
        vegetable: "Termesztett növény",
        vegetable2: "Másodvetés",
        area_fromgeom: "Rajzolt terület",
        area_size: "Becsült terület",
        saps: "SAPS",
        kat_thet: "KAT/THÉT",
        akg: "AKG",
        emva: "Gyepterület támogatás EMVA"
      };

      $scope.adatlap = {};
      // $scope.adatlap.featureId = $scope.feature.getProperties().id;
      $scope.adatlap.id = null;
      $scope.adatlap.name = $scope.feature.getProperties().name;
      $scope.adatlap.area_fromgeom = $scope.feature.getProperties().area_ha;
      // geometriát mindig a feature aktuális méretéből állapítsa meg
      var geom = pggJstsProvider.getConfig().ol3Parser.read($scope.feature.getGeometry());
      $scope.adatlap.area_fromgeom = parseFloat(geom.getArea() / 10000).toFixed(2);
      // igazából ez az adatlap neve
      $scope.adatlap.agronomist_area_name = pggAdatlapProvider.createNullOptions();
      $scope.adatlap.handled_year = pggAdatlapProvider.createYearOptions(2010);

      $scope.adatlap.area_size = pggAdatlapProvider.createNullOptions();
      $scope.adatlap.saps = pggAdatlapProvider.createTrueFalseOptions();
      $scope.adatlap.kat_thet = pggAdatlapProvider.createTrueFalseOptions();
      $scope.adatlap.emva = pggAdatlapProvider.createTrueFalseOptions();
      $scope.adatlap.vegetable = pggAdatlapProvider.getOptions().vegetable;
      $scope.adatlap.vegetable2 = pggAdatlapProvider.getOptions().vegetable2;
      $scope.adatlap.akg = pggAdatlapProvider.getOptions().akg;
      $scope.adatlap.cultivation = pggAdatlapProvider.getOptions().cultivation;

      if (!angular.equals({}, $scope.datasheet)) {
        $scope.adatlap.id = $scope.datasheet.id;
        $scope.adatlap.name = feature.getProperties().name;
        $scope.adatlap.agronomist_area_name.value = $scope.datasheet.agronomist_area_name;
        $scope.adatlap.handled_year.selected = pggAdatlapProvider.getOptionForValue(
          $scope.adatlap.handled_year, $scope.datasheet.handled_year);
        $scope.adatlap.area_size.value = $scope.datasheet.area_size;
        $scope.adatlap.cultivation.selected = pggAdatlapProvider.getOptionForId($scope.adatlap.cultivation,
          $scope.datasheet.cultivation_type_id);
        $scope.adatlap.saps.selected = pggAdatlapProvider.getOptionForId($scope.adatlap.saps,
          $scope.datasheet.saps);
        $scope.adatlap.kat_thet.selected = pggAdatlapProvider.getOptionForId($scope.adatlap.kat_thet,
          $scope.datasheet.kat_thet);
        $scope.adatlap.akg.selected = pggAdatlapProvider.getOptionForId($scope.adatlap.akg,
          $scope.datasheet.akg_id);
        $scope.adatlap.emva.selected = pggAdatlapProvider.getOptionForId($scope.adatlap.emva,
          $scope.datasheet.emva);
        $scope.adatlap.vegetable.selected = pggAdatlapProvider.getOptionForId($scope.adatlap.vegetable,
          $scope.datasheet.vegetable_id);
        // $scope.adatlap.vegetable2.selected = null;
        $scope.adatlap.vegetable2.selected = pggAdatlapProvider.getOptionForId($scope.adatlap.vegetable2, $scope.datasheet.vegetable2_id);
      } else {
        $scope.adatlap.cultivation.selected = null;
        $scope.adatlap.vegetable.selected = null;
        $scope.adatlap.vegetable2.selected = null;
        $scope.adatlap.saps.selected = null;
        $scope.adatlap.akg.selected = null;
        $scope.adatlap.emva.selected = null;
      }

      // "OK" gomb megnyomása
      $scope.ok = function () {
        // kiválasztott és kitöltött értékek begyűjtése

        var selected = {
          // alapadatok
          id: $scope.adatlap.id,
          agronomist_area_geom_id: $scope.feature.getProperties().id,
          // kötelezően kitöltendő paraméterek
          agronomist_area_name: $scope.adatlap.agronomist_area_name.value,
          handled_year: $scope.adatlap.handled_year.selected.value,
          cultivation_type_id: $scope.adatlap.cultivation.selected.id,
          vegetable_id: $scope.adatlap.vegetable.selected.id,
          vegetable2_id: (typeof $scope.adatlap.vegetable2.selected == "undefined" || $scope.adatlap.vegetable2.selected === null) ? null : $scope.adatlap.vegetable2.selected.id,
          // opcionálisan kitöltendő paraméterek
          area_size: $scope.adatlap.agronomist_area_size === null ? null : +parseFloat(
            $scope.adatlap.area_size.value).toFixed(2),
          saps: (typeof $scope.adatlap.saps.selected == "undefined" || $scope.adatlap.saps.selected === null) ? null : $scope.adatlap.saps.selected.id,
          kat_thet: (typeof $scope.adatlap.kat_thet.selected == "undefined" || $scope.adatlap.kat_thet.selected === null) ? null : $scope.adatlap.kat_thet.selected.id,
          akg_id: (typeof $scope.adatlap.akg.selected == "undefined" || $scope.adatlap.akg.selected === null) ? null : $scope.adatlap.akg.selected.id,
          emva: (typeof $scope.adatlap.emva.selected == "undefined" || $scope.adatlap.emva.selected === null) ? null : $scope.adatlap.emva.selected.id
        };
        // modal bezárása, eredmény visszaküldése
        $uibModalInstance.close(selected);
      };

      // "Mégsem" gomb megnyomása
      $scope.cancel = function () {
        $uibModalInstance.dismiss('cancel');
      };
    }]);
